import { render, staticRenderFns } from "./GAddButton.vue?vue&type=template&id=5bfb8f35&scoped=true&"
import script from "./GAddButton.vue?vue&type=script&lang=ts&"
export * from "./GAddButton.vue?vue&type=script&lang=ts&"
import style0 from "./GAddButton.vue?vue&type=style&index=0&id=5bfb8f35&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfb8f35",
  null
  
)

export default component.exports